import type { CustomField } from '@interfaces/customField';
import { evaluateTriggerRules } from './evaluateTriggerRules';

export const modifyUpdatingCustomFields = (
  userCustomFields: { key: string; value?: unknown }[],
  derivedCustomFields: CustomField[],
  activeCustomFieldKeys?: string[],
): { key: string; value?: unknown }[] => {
  const customFieldArray: { key: string; value?: unknown }[] = [];
  const keysWithData: string[] = [];
  userCustomFields &&
    userCustomFields.map((field: { key: string; value?: unknown }) => {
      if (activeCustomFieldKeys?.includes(field.key)) {
        keysWithData.push(field.key);
        customFieldArray.push({
          key: field.key,
          value: field.value,
        });
      }
    });
  derivedCustomFields?.map((f: CustomField) => {
    if (!keysWithData.includes(f.key) && f.type === 'BOOLEAN') {
      if (activeCustomFieldKeys?.includes(f.key)) {
        customFieldArray.push({
          key: f.key,
          value: false,
        });
      }
    }
  });
  derivedCustomFields?.map((dcf: CustomField) => {
    if (
      dcf.conditionalRules?.length &&
      dcf.conditionalRules.length > 0 &&
      !keysWithData.includes(dcf.key) &&
      activeCustomFieldKeys?.includes(dcf.key)
    ) {
      const result = evaluateTriggerRules(dcf, userCustomFields);
      if (!result) {
        customFieldArray.push({
          key: dcf.key,
          value: null,
        });
      }
    }
  });
  return customFieldArray;
};
